import { render, staticRenderFns } from "./marketing-task-skeleton.vue?vue&type=template&id=f3aa842e&scoped=true&lang=pug&"
import script from "./marketing-task-skeleton.vue?vue&type=script&lang=js&"
export * from "./marketing-task-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./marketing-task-skeleton.vue?vue&type=style&index=0&id=f3aa842e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa842e",
  null
  
)

export default component.exports